<template>
  <div class="JoinUs-box" id="JoinUs">
    <div>
      <div class="JoinUs-top">
        <h1>{{ $t("JoinUs.title") }}</h1>
        <p>{{ $t("JoinUs.describe") }}</p>
      </div>
      <div class="JoinUs-bot">
        <div class="JoinUs-bot-left">
          <p>
            {{ $t("JoinUs.JoinUsText") }}
          </p>
          <p>
            {{ $t("JoinUs.name") }}
          </p>
          <p>
            {{ $t("JoinUs.address") }}
          </p>
          <p>
            {{ $t("JoinUs.mailbox") }}
          </p>
          <p>
            {{ $t("JoinUs.phone") }}
          </p>
          <img src="@/assets/map.png" alt="" />
        </div>
        <div class="JoinUs-bot-right">
          <p>
            {{ formdata.title }}
          </p>
          <el-form
            ref="elForm"
            :model="form"
            size="medium"
            label-width="100px"
            label-position="top"
          >
            <el-form-item :label="formdata.nameLable" prop="mobile">
              <el-input
                v-model="form.name"
                placeholder=""
                :maxlength="11"
                clearable
                :style="{ width: '100%' }"
              ></el-input>
            </el-form-item>
            <el-form-item :label="formdata.mailboxLable" prop="field101">
              <el-input
                v-model="form.mailbox"
                placeholder=""
                clearable
                :style="{ width: '100%' }"
              >
              </el-input>
            </el-form-item>
            <el-form-item :label="formdata.phoneLable" prop="field102">
              <el-input
                v-model="form.mobile"
                placeholder=""
                clearable
                :style="{ width: '100%' }"
              >
              </el-input>
            </el-form-item>
            <el-form-item :label="formdata.formLable" prop="field103">
              <el-upload
                :on-change="handlePreview"
                :action="action"
                :on-remove="handleRemove"
                :file-list="fileList"
                :auto-upload="false"
                :before-upload="beforeAvatarUpload"
              >
                <el-button size="small" type="primary" icon="el-icon-upload">{{
                  formdata.formUploadLable
                }}</el-button>
                <!-- <p>{{ formdata.fileTypeLable }}</p> -->
              </el-upload>
            </el-form-item>

            <el-form-item size="large">
              <div class="checkbox">
                <el-checkbox v-model="checkbox"></el-checkbox>
                <p v-html="formdata.userNotice" @click="onUserNotice"></p>
              </div>
            </el-form-item>
            <el-form-item size="large">
              <el-button
                @click="submitForm"
                type="primary"
                class="button"
                round
                >{{ formdata.buttonText }}</el-button
              >

              <el-button
                type="danger"
                round
                class="download"
                @click="dialogVisible = true"
              >
                {{ formdata.downloadText }}
              </el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <el-dialog
      title=" "
      :visible.sync="dialogVisible"
      width="50%"
      :before-close="handleClose"
    >
      <div>
        <el-button type="danger" round class="download">
          <a :href="'./static/' + enterpriseFiles">{{
            formdata.enterpriseFilesText
          }}</a>
        </el-button>
        <el-button type="danger" round class="download">
          <a :href="'./static/' + thatPersonFiles">{{
            formdata.thatPersonFilesText
          }}</a>
        </el-button>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import * as qiniu from "qiniu-js";
import axios from "axios";
import CryptoJS from "crypto-js";
import { Loading, Message } from "element-ui";
export default {
  data() {
    return {
      form: {
        name: "",
        mailbox: undefined,
        mobile: undefined,
        file: null,
      },
      dialogVisible: false,
      action: uploadUrl,
      fileList: [],
      url: filesUrl,
      checkbox: false,
      qiNiu: {
        AccessKey: AccessKey,
        SecretKey: SecretKey,
      },
      token: "",
    };
  },
  computed: {
    formdata() {
      return this.$t("JoinUs.formdata");
    },

    thatPersonFiles() {
      return this.$t("JoinUs.thatPersonFiles");
    },
    enterpriseFiles() {
      return this.$t("JoinUs.enterpriseFiles");
    },
  },
  mounted() {},
  methods: {
    getQiniuToken(req, res) {
      const that = this;
      let timestamp = new Date().getTime(); // 当前的时间戳

      timestamp = parseInt(timestamp / 1000)+1000 ;
      let putPolicy = { scope: "hk-store", deadline: timestamp };

      let encodedPutPolicy = CryptoJS.enc.Base64.stringify(
        CryptoJS.enc.Utf8.parse(JSON.stringify(putPolicy))
      );

      let encodedSign = CryptoJS.enc.Base64.stringify(
        CryptoJS.HmacSHA1(encodedPutPolicy, that.qiNiu.SecretKey)
      ); // 第一个参数为加密字符串，第二个参数为公共秘钥

      return that.qiNiu.AccessKey + ":" + encodedSign + ":" + encodedPutPolicy;
    },
    async handlePreview(file) {
      const token = await this.getQiniuToken();

      // const a = token.replace("s", "");
      // const tokens = a.replace("", "");
      // console.log(tokens, token);
      const folesInfo = file.raw;
      console.log(file);
      const that = this;
        let timestamp = new Date().getTime();
      const observable = qiniu.upload(file.raw, timestamp+file.name, token);
      const observer = {
        next(res) {},
        error(res) {
          that.fileList = [];
          console.log(res);
          that.$message({
            showClose: true,
            message: "error",
            type: "warning",
            offset: 80,
          });
        },
        complete(res) {
          that.form.file = `${that.url}/${res.key}`;

          //执行上传成功后的逻辑
        },
      };
      observable.subscribe(observer);
    },
    beforeAvatarUpload() {},
    submitForm() {
      const { name, mailbox, mobile, file } = this.form;

      if (name && mailbox && mobile && file) {
        console.log(this.fileList);
        let formdata = new FormData();

        formdata.append("姓名", this.form.name);
        formdata.append("电子邮箱", this.form.mailbox);
        formdata.append("联系电话", this.form.mobile);
        formdata.append("入会表单", this.form.file);
        const loadingInst = Loading.service({
          lock: true,
          text: "loading...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.5)",
        });

        axios({
          method: "post", //必须post请求
          url: mailUrl, //test换成你要接收的邮箱地址
          async: true,
          data: formdata,
          headers: {
            "Content-Type": "text/html; charset=utf-8",
          },
        })
          .then((response) => {
            loadingInst.close();

            this.$router.push("/success");
          })
          .catch((err) => {
            loadingInst.close();
            that.$message({
              showClose: true,
              message: "upload error",
              type: "warning",
              offset: 80,
            });
          });
      } else {
        console.log(this.form);

        this.$message({
          showClose: true,
          message: this.formdata.formMassge,
          type: "warning",
          offset: 80,
        });
      }
    },
    resetForm() {
      this.$refs["elForm"].resetFields();
    },

    handleClose() {},
    onUserNotice() {
      this.$router.push("JoinUs");
    },
    handleRemove() {
      this.fileList = [];
      this.form.file = "";
    },
  },
};
</script>
<style lang="less" >
.JoinUs-box {
  .el-form-item__label {
    font-size: 16px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: #000000;
    line-height: 22px;
  }

  .el-form-item {
    margin-top: 18px;
  }

  .el-upload {
    text-align: left;
  }

  .el-button--danger {
    background-color: #ff5200;
  }

  .checkbox {
    display: flex;
    line-height: 22px !important;
    margin-top: -15px;

    p {
      margin-left: 10px;
      font-size: 14px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      color: #000000;
      cursor: pointer;
    }
  }

  .el-input__inner {
    width: 400px;
  }

  .button {
    width: 180px;
    height: 54px;

    border-radius: 27px;
    font-size: 16px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    // color: #FFFFFF;
  }

  .download {
    width: 180px;
    height: 54px;

    border-radius: 27px;

    font-size: 16px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;

    a {
      color: inherit;
      text-decoration: none;
    }

    //   color: #FFFFFF;
  }
}

@media screen and (max-width: 1080px) {
  .JoinUs-box {
    .el-form-item__label {
      font-size: 3.5rem;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      color: #000000;
      line-height: 5rem;
    }

    .el-form-item {
      margin-top: 4rem;
    }

    .el-upload {
      text-align: left;
    }

    .checkbox {
      display: flex;
      line-height: 5rem !important;
      margin-top: -3rem;

      p {
        margin-left: 2rem;
        font-size: 3.5rem;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #000000;
        cursor: pointer;
      }
    }

    .el-input__inner {
      width: 98rem;
    }

    .button {
      width: 45rem;
      height: 11rem;
      border-radius: 6.8rem;
      font-size: 4rem;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      // color: #FFFFFF;
    }

    .download {
      width: 45rem;
      height: 11rem;
      border-radius: 6.8rem;
      font-size: 4rem;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;

      a {
        color: inherit;
        text-decoration: none;
      }

      //   color: #FFFFFF;
    }
  }
}
</style>
<style lang="less" scoped>
.JoinUs-box {
  width: 100%;
  background-color: #fff;
  padding: 60px 0;

  > div {
    width: 1280px;
    margin: auto;
  }

  .JoinUs-top {
    text-align: center;

    h1 {
      font-size: 40px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      color: #000000;
      line-height: 56px;
      margin-bottom: 10px;
    }

    p {
      font-size: 16px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      color: #000000;
      line-height: 22px;
      margin-bottom: 60px;
    }
  }

  .JoinUs-bot {
    display: flex;
    justify-content: space-between;

    .JoinUs-bot-left {
      width: 600px;
      height: 557px;
      background: #f1f3f8;
      border-radius: 12px;
      padding: 40px;
      box-sizing: border-box;

      img {
        width: 418px;
        height: 232px;
        margin-top: 24px;
      }

      p:nth-child(1) {
        font-size: 24px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        color: #000000;
        margin-bottom: 44px;
        line-height: 33px;
      }

      p:nth-child(2) {
        font-size: 16px;
        font-family: MiSans, MiSans;
        font-weight: 600;
        color: #000000;
        line-height: 22px;
        margin-bottom: 12px;
      }

      p:nth-child(3),
      p:nth-child(4) {
        font-size: 16px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #000000;
        line-height: 22px;
        margin-bottom: 20px;
      }
    }

    .JoinUs-bot-right {
      width: 600px;
      height: 557px;

      > p {
        font-size: 24px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        color: #0041f0;
        line-height: 33px;
      }
    }
  }
}

@media screen and (max-width: 1080px) {
  .JoinUs-box {
    width: 108rem;
    background-color: #fff;
    padding-top: 8rem;

    > div {
      width: 100%;
      margin: auto;
    }

    .JoinUs-top {
      text-align: center;

      h1 {
        font-size: 5rem;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        color: #000000;
        line-height: 7rem;
        margin-bottom: 2rem;
      }

      p {
        font-size: 3rem;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.5);
        line-height: 4.3rem;
        margin-bottom: 4rem;
      }
    }

    .JoinUs-bot {
      display: flex;
      justify-content: space-between;

      flex-direction: column-reverse;

      .JoinUs-bot-left {
        width: 108rem;
        height: 100%;
        background: #f1f3f8;
        border-radius: 0;

        padding: 5rem;
        box-sizing: border-box;

        img {
          width: 98rem;
          height: 55rem;
          margin-top: 6rem;
        }

        p:nth-child(1) {
          font-size: 5.3rem;
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          color: #000000;
          margin-bottom: 6rem;
          line-height: 7.3rem;
        }

        p:nth-child(2) {
          font-size: 4rem;
          font-family: MiSans, MiSans;
          font-weight: 600;
          color: #000000;
          line-height: 5.6rem;
          margin-bottom: 3.8rem;
        }

        p:nth-child(3),
        p:nth-child(4) {
          font-size: 4rem;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          color: #000000;
          line-height: 5.6rem;
          margin-bottom: 4rem;
        }
      }

      .JoinUs-bot-right {
        width: 108rem;
        height: 100%;
        padding: 5rem;
        box-sizing: border-box;

        > p {
          font-size: 5.3rem;
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          color: #0041f0;
          line-height: 7.3rem;
        }
      }
    }
  }
}
</style>